import 'swiper/swiper-bundle.css';

import { Image } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTheme } from 'styled-components';
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import * as S from './style';

function ProductGallery({ images, setSwiperRef }) {
  const theme = useTheme();
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  return (
    <S.ProductGallery>
      <Swiper
        style={{
          '--swiper-navigation-color': 'var(--color-fg-inverse-default)',
          '--swiper-pagination-color': 'var(--color-fg-inverse-default)',
          '--swiper-navigation-size': 20
        }}
        spaceBetween={10}
        navigation
        onSwiper={swiper => {
          setSwiperRef(swiper);
        }}
        touchStartPreventDefault={false}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[Navigation, Thumbs]}
      >
        {images?.map(image => (
          <SwiperSlide key={image.url}>
            <S.ImageWrapper>
              <Image src={image.url} errorSrc={theme.images.noImage} />
            </S.ImageWrapper>
          </SwiperSlide>
        ))}
      </Swiper>
      <Swiper
        style={{ marginRight: 8, minWidth: 80, maxWidth: 80 }}
        direction="vertical"
        onSwiper={swiper => {
          setThumbsSwiper(swiper);
        }}
        observer
        observeParents
        spaceBetween={8}
        slidesPerView={4}
        freeMode
        watchSlidesProgress
        modules={[FreeMode, Navigation, Thumbs]}
      >
        {images?.map(image => (
          <SwiperSlide key={image.url} style={{ minHeight: 88, maxHeight: 88 }}>
            <S.ImageThumbWrapper>
              <Image src={image.url} />
            </S.ImageThumbWrapper>
          </SwiperSlide>
        ))}
      </Swiper>
    </S.ProductGallery>
  );
}

ProductGallery.propTypes = {
  images: PropTypes.array,
  setSwiperRef: PropTypes.func
};

export { ProductGallery };
